import styled from "styled-components";

/**
 * Shared card + horizontal slide-rail chrome for presentation template list items
 * (Team Templates and Beautiful.ai Templates).
 */
export const PresentationTemplateCard = styled.div`
    width: 100%;
    min-width: 0;
    margin-bottom: 12px;
    background: #FFF;
    padding: 10px 15px 5px;
    border: none;
    border-radius: 4px;
    overflow: hidden;
    transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;

    &:hover {
        cursor: default;
        background: #F8FAFB;
        box-shadow: inset 0 0 0 1px #DDE3E8;
    }

    &.selected {
        background: #D5E6ED;

        &:hover {
            cursor: default;
            background: #D5E6ED;
        }
    }

    .title {
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: #222;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .thumbnail {
        border-radius: 1px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
        transition: box-shadow 0.2s ease;
    }

    .thumbnail img {
        border-radius: 1px;
    }
`;

export const PresentationTemplateHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    min-width: 0;
    min-height: 28px;
`;

export const PresentationTemplateSlideRailContainer = styled.div`
    position: relative;
    width: 100%;
    min-width: 0;
    height: 110px;
    margin-top: 4px;
`;

export const PresentationTemplateSlideRail = styled.div`
    position: absolute;
    inset: 0;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 164px;
    align-items: start;
    overflow-x: auto;
    overflow-y: hidden;
    gap: 8px;
    padding: 0 2px;
    box-sizing: border-box;
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar-thumb:horizontal {
        background-color: transparent;
    }

    &:hover {
        scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
    }

    &:hover::-webkit-scrollbar-thumb:horizontal {
        background-color: rgba(0, 0, 0, 0.2);
    }
`;
